import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { charmGray, white } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'grid',
		gridTemplateColumns: 'auto 1fr',
		gap: 16,
		backgroundColor: white,
		padding: 16,
		flex: 1,
		overflow: 'hidden',
		boxSizing: 'border-box',
		[THEME.queries.lg]: {
			gridTemplateColumns: '1fr',
			gridTemplateRows: 'auto 1fr',
		},
	},
	tabListScrollArea: {
		height: '100%',
	},
	tabList: {
		height: 'auto !important',
		overflow: 'auto',
	},
	tabContent: {
		overflow: 'auto',
	},
	tagsTabContent: {
		overflow: 'hidden',
	},
	mobileNav: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		boxSizing: 'border-box',
		padding: 8,
	},
	mobileNavTrigger: {
		width: '100%',
		justifyContent: 'flex-start',
	},
	mobileNavList: {
		maxHeight: 320,
		overflowY: 'auto',
		':is([data-orientation="vertical"])': {
			borderRight: 'none',
		},
	},
	accountDetailsHeader: {
		boxSizing: 'border-box',
		paddingTop: 24,
	},
	integrationsSearchInput: {
		marginBottom: 20,
		maxWidth: 400,
		width: '100%',
	},
	placeholderContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		color: '#999',
		fontSize: 18,
	},
	content: {
		minWidth: 1118,
		// Drop the fixed desktop floor so the page can shrink to the viewport once
		// the tab rail collapses. Individual wide tab contents still reflow separately.
		/* [THEME.queries.lg]: {
			minWidth: 0,
		}, */
	},
	unauthorized: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		gap: 8,
	},
	contentCalendarButton: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		color: charmGray,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
		padding: '16px 16px 8px 16px',
		':hover': {
			backgroundColor: '#f7fafc',
		},
	},
	classicViewAction: {
		alignItems: 'center',
		color: charmGray,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
});
